/** BFP-531 — payment history placeholder until billing module ships. */

export type SensemakerPaymentType =
  | 'Sign-up Package Payment'
  | 'AI Token Top-up'
  | 'Instrument Charges'

export type SensemakerPaymentStatus = 'Paid' | 'Payment Failed'

export interface SensemakerPaymentBreakdown {
  instrumentCostUsd: number
  publishingCostUsd: number
  platformChargeUsd: number
}

export interface SensemakerPaymentRow {
  id: string
  date: string
  type: SensemakerPaymentType
  amountUsd: number
  status: SensemakerPaymentStatus
  breakdown?: SensemakerPaymentBreakdown
}

export interface SensemakerPaymentMock {
  packageAmountPurchasedUsd: number | null
  totalInstrumentCostUsd: number
  instrumentPublicationCostUsd: number | null
  rows: SensemakerPaymentRow[]
}

export function buildSensemakerPaymentMock(
  totalInstrumentCostUsd: number,
): SensemakerPaymentMock {
  return {
    packageAmountPurchasedUsd: null,
    totalInstrumentCostUsd,
    instrumentPublicationCostUsd: null,
    rows: [],
  }
}
